import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { Side } from '@/common/constants';
import { createShortcutTarget } from '@/utils/shortcutTarget';
import type { OrderFormData } from '../order_schema';
import { OrderType } from '../order_types';

export type OrderFormShortcutRequest = { kind: 'side'; side: Side } | { kind: 'toggleMarketLimit' };

/** L / S / O: change the mounted order form. */
export const orderFormShortcut = createShortcutTarget<[OrderFormShortcutRequest]>();

export function useOrderFormShortcuts(methods: UseFormReturn<OrderFormData>) {
  useEffect(
    () =>
      orderFormShortcut.register((request) => {
        // Validate like a click on SideSwitch / the order-type tabs (field.onChange in mode 'onChange').
        const options = { shouldDirty: true, shouldValidate: true };
        if (request.kind === 'side') {
          methods.setValue('side', request.side, options);
        } else {
          // O: Market ↔ Limit. From a stop type it goes to Limit.
          const next = methods.getValues('orderType') === OrderType.limit ? OrderType.market : OrderType.limit;
          methods.setValue('orderType', next, options);
        }
        return true;
      }),
    [methods]
  );
}
